<template>
  <WidgetCard
    title="URLs with most total alerts"
    icon="notification"
    :loading="loading"
    :error="error"
    :empty="emptyMessage"
  >
    <template #headerExtra>
      <a-radio-group :value="days" @change="onChangeWindow">
        <a-radio-button :value="1">
          1D
        </a-radio-button>
        <a-radio-button :value="3">
          3D
        </a-radio-button>
        <a-radio-button :value="7">
          7D
        </a-radio-button>
        <a-radio-button :value="14">
          14D
        </a-radio-button>
        <a-radio-button :value="30">
          30D
        </a-radio-button>
      </a-radio-group>
    </template>
    <template v-if="ready">
      <div class="dw-rank">
        <div v-for="row in rows" :key="row.id" class="dw-rank__row">
          <router-link
            class="dw-rank__name"
            :to="{ path: '/incident/list', query: { search: row.url || row.name } }"
            :title="row.url || row.name"
          >{{ row.url || row.name }}</router-link>
          <span class="dw-rank__count">
            <strong>{{ row.count.toLocaleString() }}</strong> alerts
          </span>
          <span class="dw-rank__bar">
            <span class="dw-rank__fill" :style="{ width: barWidth(row.count) }" />
          </span>
        </div>
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';
  import dashboardFilters from '../../mixins/dashboardFilters.mixin';

  export default {
    name: 'TopNoisyUrlsWidget',
    components: { WidgetCard },
    mixins: [dashboardWidget, dashboardFilters],
    data() {
      return {
        days: 7,
        rows: []
      };
    },
    computed: {
      ready() {
        return !this.loading && !this.error && this.rows.length > 0;
      },
      emptyMessage() {
        return !this.loading && !this.error && this.rows.length === 0
          ? 'No alerts in this period'
          : '';
      },
      max() {
        return this.rows.reduce((m, r) => Math.max(m, r.count), 0) || 1;
      }
    },
    methods: {
      cacheDescriptors() {
        return [DashboardService.resources.topNoisy(this.days, this.tagIds, this.planTypes)];
      },
      barWidth(count) {
        return `${(count / this.max) * 100}%`;
      },
      onChangeWindow(e) {
        this.days = e.target.value;
        this.fetchData();
      },
      fetchResource() {
        return DashboardService.fetchTopNoisyUrls(this.days, this.tagIds, this.planTypes);
      },
      applyResult(rows) {
        this.rows = rows;
      }
    }
  };
</script>
